/* eslint-disable max-lines-per-function */
/* eslint-disable max-statements-per-line */
import './Global.scss';
import '@mvps-genesis/hook';
import ContinueShopping from '@mvps-genesis/continue-shopping';
import {PageManager} from '@mvps-genesis/core';
import {GlobalMessageContainer} from '@mvps-genesis/messages';
import MiniBasket from '@mvps-genesis/mini-basket';
import {initCarousels} from '@mvps-genesis/carousel';
import dynamicFormElementAttributes from '@mvps-genesis/dynamic-form-element-attributes';
import {HTMLFormValidator} from '@mvps-genesis/form-validation';
import 'extensions/age-verification/age-verification';
import ScrollToTop from 'extensions/scroll-to-top/scrollToTop';
import '@mvps-genesis/fasten-header';
import 'whatwg-fetch';
import EventBus from '@mvps-genesis/event-bus';
import 'formdata-polyfill';
import Listrak from 'extensions/listrak/Listrak';
import AjaxAddToCartExtended from 'extensions/ajax-add-to-cart/AjaxAddToCart.js';
import WaitListAdd from 'extensions/waitlist/WaitList.js';
import 'extensions/waitlist/WaitList.scss';

export default class Global extends PageManager {

	constructor (pageContext) {

		super(pageContext);

		// Register functions
		window.AjaxAddToCartExtended = AjaxAddToCartExtended;
		window.WaitListAdd = WaitListAdd;

	}

	// eslint-disable-next-line max-lines-per-function
	onReady () {

		/**
		 * Toggle the `is-open` state of the global account box.
		 */
		(function () {
			var trigger = document.querySelector('[data-hook="show-related"]');
			var elClicked = false;

			if (trigger) {
				var relatedTarget = document.querySelector('[data-hook="' + trigger.getAttribute('data-target') + '"]');

				if (relatedTarget) {

					document.querySelectorAll('[data-hook="show-related"]').forEach(item => {
						item.addEventListener('click', event => {
							// Handle click
							elClicked = event.target;
							event.preventDefault();
							relatedTarget.classList.toggle('is-open');
						});
					});

					/**
					 * // Commenting Out Code.
					 * trigger.addEventListener('click', function (event) {
					 * event.preventDefault();
					 * relatedTarget.classList.toggle('is-open');
					 * }, false);
					 */

					document.addEventListener('mousedown', function (event) {
						if (relatedTarget.classList.contains('is-open')) {
							if (!relatedTarget.contains(event.target) && !elClicked.parentElement.contains(event.target)) {
								relatedTarget.classList.toggle('is-open');
								event.preventDefault();
							}
						}
					}, false);

					window.addEventListener('keydown', function (event) {
						if (event.defaultPrevented) {
							return;
						}

						switch (event.key) {
						case 'Escape':
							if (relatedTarget.classList.contains('is-open')) {
								relatedTarget.classList.toggle('is-open');
							}
							break;
						default:
						}
					}, true);

					/**
					 * Remove the `is-open` state of the global account box
					 * when the fasten header is visible
					 */
					window.addEventListener('scroll', function () {
						if (document.body.classList.contains('x-fasten-header--is-active')) {
							if (relatedTarget.classList.contains('is-open')) {
								relatedTarget.classList.toggle('is-open');
							}
						}
					});

				}

			}
		}());

		const footerNewsletterForm = document.getElementById('js-footer-newsletter-form');

		var footerNewsletterFormSubmit = function (event) {
			event.preventDefault();
			let email = footerNewsletterForm.querySelector('input[name="3"]');
			const fieldWrap = footerNewsletterForm.querySelector('.t-newsletter-form__field-wrap');
			if (email.validity.valid) {
				// Valid
				fieldWrap.classList.remove('has-error');
				footerNewsletterForm.submit();
			} else {
				// Invalid
				fieldWrap.classList.add('has-error');
			}
		};

		if (footerNewsletterForm) {
			footerNewsletterForm.addEventListener('submit', footerNewsletterFormSubmit);
			if (!footerNewsletterForm.hasAttribute('novalidate')) {
				footerNewsletterForm.setAttribute('novalidate', true);
			}
		}

		/**
		 * Initialize scroll to top functionality
		 */
		new ScrollToTop('js-mobile-scroll-to-top-button');

		/**
		 * Initialize continue shopping link
		 */
		new ContinueShopping();

		/**
		 * Create global message container
		 */
		new GlobalMessageContainer({container: '#js-messages'});

		/**
		 * Listrak JavaScript integration.
		 * Note: This should be loaded before the MiniBasket extension to avoid
		 * issue with mini basket elements being replaced.
		 */
		new Listrak();

		/**
		 * Initialize the Mini-Basket extension
		 */
		new MiniBasket();

		/**
		 * Initialize the Drop-Down Navigation extension
		 */
		if (document.querySelector('[data-hook="transfigure-navigation"]')) {
			import('extensions/transfigure-navigation/transfigure-navigation.js').then(function () {
				$.hook('has-drop-down').transfigureNavigation();
			});
		}

		/**
		 * Initialize carousels
		 */
		initCarousels();

		/**
		 * Initialize Inline Form Validations
		 */
		(function initializeHTMLFormValidator () {
			document.querySelectorAll('.js-form-validator').forEach(function (form) {
				form.HTMLFormValidator = new HTMLFormValidator({
					formElement: form,
					wrapperSelector: '.c-form-list__item'
				});
			});
		}());

		/**
		 * Initialize the Dynamic Form-Element Attributes
		 */
		dynamicFormElementAttributes();

		/**
		 * Mini Modal
		 */
		(async () => {
			// Elements
			const miniModalElements = Array.from(document.querySelectorAll('[data-mini-modal]'));

			if (miniModalElements.length === 0) { return; }

			// Module
			const {default: minimodal} = await import('@mvps-genesis/minimodal');

			// Initiate the modal for each element
			miniModalElements.forEach(element => {
				minimodal(element).init();
			});
		})();

		/**
		 * Initialize Accordion Polyfill
		 */
		(() => {
			// Elements
			const accordionElements = document.getElementsByClassName('x-accordion');

			if (accordionElements.length === 0) {
				return;
			}

			// Module
			import('details-polyfill');

		})();

		/**
		 * Initialize LazyLoading
		 */
		(() => {
			// Elements
			const lazyLoadElements = document.getElementsByClassName('lazyload');

			if (lazyLoadElements.length === 0) {
				return;
			}

			// Module
			import('lazysizes');
			import('lazysizes/plugins/unveilhooks/ls.unveilhooks');
			import('lazysizes/plugins/bgset/ls.bgset');
			import('lazysizes/plugins/custommedia/ls.custommedia');
		})();

		/**
		 * "Lazy load" main navigation images
		 */
		$('.c-navigation__link').on('mouseover click', function () {
			$(this).closest('.t-navigation__parent').find('.t-navigation-lazyload')
				.each(function () {
					var $this = $(this);
					$this.attr('src', $this.data('src'));
					$this.addClass('t-navigation-lazyloaded');
					$this.removeClass('t-navigation-lazyload');
				});
		});

		/**
		 * Smooth Scroll Extension
		 * https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
		 */
		(() => {
			const scrollTriggers = document.getElementsByClassName('js-scroll-trigger');
			if (scrollTriggers.length) {
				for (const triggerElement of scrollTriggers) {
					let anchorHrefAttribute = triggerElement.getAttribute('href');
					let scrollToElement = document.querySelector(anchorHrefAttribute);

					if (scrollToElement) {
						triggerElement.addEventListener('click', function (event) {
							event.preventDefault();
							scrollToElement.scrollIntoView({behavior: 'smooth', block: 'center'});
						});
					}
				}
			}
		})();

		/**
		 * Mini Basket pointer change (empty or with one or more items)
		 * GTM - Add To Cart
		 */
		const cartToast = document.getElementById('js-cart-toast');
		const cartToastImage = cartToast ? cartToast.querySelector('.x-cart-toast__image-wrap img') : null;
		const cartToastMessage = cartToast ? cartToast.querySelector('.x-cart-toast-message') : null;
		const cartToatstProductName = cartToast ? cartToast.querySelector('.x-cart-toast-name') : null;
		let cartToastTimer = null;

		// eslint-disable-next-line max-lines-per-function
		EventBus.addEventListener('MVPS:addToCart', (e) => {

			if (cartToastTimer) {
				clearTimeout(cartToastTimer);
			}
			if (e.detail.success === true) {

				if (cartToast) {
					if (e.detail.productData.product_image) {
						cartToastImage.src = e.detail.productData.product_image;
					} else {
						cartToastImage.src = mivaJS.Image_Placeholder_Product;
					}
					cartToastImage.src = e.detail.productData.product_image;
					cartToastMessage.classList.remove('is-warning');
					cartToastMessage.classList.add('is-success');
					cartToastMessage.innerHTML = '+' + e.detail.formData.get('Quantity') + ' Successfully Added to Cart!';
					cartToatstProductName.innerHTML = e.detail.productData.name;
					cartToast.classList.remove('inactive');
					cartToastTimer = setTimeout(function () {
						cartToast.classList.add('inactive');
					}, 10000);
				}

				// Mini Basket pointer
				var x = document.getElementById('js-fasten-header-site-header__basket-link');
				var y = document.getElementById('js-site-header__basket-link');
				if (y.classList.contains('t-site-header__basket-link-notification-empty') || x.classList.contains('t-site-header__basket-link-notification-empty')) {
					y.classList.remove('t-site-header__basket-link-notification-empty');
					x.classList.remove('t-site-header__basket-link-notification-empty');
					y.classList.add('t-site-header__basket-link-notification', 'u-bg-style--primary');
					x.classList.add('t-site-header__basket-link-notification', 'u-bg-style--primary');
				};

				// GTM addToCart Event fired when Ajax is successful
				if (typeof window.google_tag_manager !== 'undefined' && e.detail.productData.name !== null) {
					dataLayer.push({
						'event': 'addToCart',
						'ecommerce': {
							'currencyCode': 'USD',
							'add': {
								'products': [
									{
										'name': e.detail.productData.name,
										'id': e.detail.productData.code,
										'price': e.detail.productData.price,
										'quantity': e.detail.formData.get('Quantity'),
										'product_id': e.detail.productData.product_id,
										'category': e.detail.productData.category,
										'brand': e.detail.productData.brand
									}
								]
							}
						}
					});
				}

			} else if (cartToast) {

				if (e.detail.productData.product_image) {
					cartToastImage.src = e.detail.productData.product_image;
				} else {
					cartToastImage.src = mivaJS.Image_Placeholder_Product;
				}
				cartToastMessage.classList.remove('is-success');
				cartToastMessage.classList.add('is-warning');
				cartToastMessage.innerHTML = e.detail.message;
				cartToatstProductName.innerHTML = e.detail.productData.name;
				cartToast.classList.remove('inactive');
				cartToastTimer = setTimeout(function () {
					cartToast.classList.add('inactive');
				}, 10000);
			}
		});

		/*
		 * Automat.ai Add to cart listener
		 */

		/**
		 * Generate and submit ADPM (Multi-Product Add to Cart)
		 */
		var submitADPMForm = function (data, options, path = '/basket-contents') {

			// Set form action path
			var postURL = window.location.protocol + '//' + window.location.host + path;

			// Set method to post by default if not specified.
			var method = options.method || 'post';

			// Create form element for add
			var form = document.createElement('form');
			form.setAttribute('method', method);
			form.setAttribute('action', postURL);

			const constructElements = function (item, parentString) {
				for (var key in item) {
					if (item.hasOwnProperty(key) && item[key] !== null) {
						if (Object.prototype.toString.call(item[key]) === '[object Array]') {
							for (var i = 0; i < item[key].length; i++) {
								constructElements(item[key][i], parentString + key + '[' + i + '].');
							}
						} else if (Object.prototype.toString.call(item[key]) === '[object Object]') {
							constructElements(item[key], parentString + key + '.');
						} else {
							var hiddenField = document.createElement('input');
							hiddenField.setAttribute('type', 'hidden');
							hiddenField.setAttribute('name', parentString + key);
							hiddenField.setAttribute('value', item[key]);
							form.appendChild(hiddenField);
						}
					}
				}
			};

			// If the parent 'data' object is an array we need to treat it a little differently
			if (Object.prototype.toString.call(data) === '[object Array]') {
				if (typeof options.arrayName === 'undefined') {
					console.warn('Posting array-type to url will doubtfully work without an arrayName defined in options.');
				};

				// Loop through each array item at the parent level
				for (var i = 0; i < data.length; i++) {
					constructElements(data[i], (options.arrayName || '') + '[' + data[i].code + ']:');
				}
			} else {
				// Otherwise treat it normally
				constructElements(data, '');
			}

			// Set Miva Action
			var actionField = document.createElement('input');
			actionField.setAttribute('type', 'hidden');
			actionField.setAttribute('name', 'Action');
			actionField.setAttribute('value', 'ADPM');
			form.appendChild(actionField);
			document.body.appendChild(form);
			form.submit();
		};

		// Test code / function - remmove before deployment
		var el = document.getElementById('js-button');
		if (el !== null) {
			el.addEventListener('click', function () {
				// Rename object keys to match what we need in Miva
				var data = addProd.map(elm => ({
					code: elm.productId,
					quantity: elm.quantity,
					variant_code: elm.variantId
				}));

				var options = {
					arrayName: 'Products'
				};

				submitADPMForm(data, options);
			});
		}

		// Capture and handle Automat.ai ATC event.
		window.addEventListener(
			'automat/addProductsToCartRequest',
			function (event) {

				// Rename object keys to match what we need in Miva
				var data = event.detail.map(elm => ({
					code: elm.productId,
					quantity: elm.quantity,
					variant_code: elm.variantId
				}));

				var options = {
					arrayName: 'Products'
				};

				// Create and submit form
				submitADPMForm(data, options);

			}
		);
	}
}
